import {
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from "@/components/ui/Dropdown";
import { Tooltip } from "@/components/ui/Tooltip";
import { LoaderCircle, type LucideIcon } from "lucide-react";

export type MenuItem = {
  condition: boolean;
  disabledTooltip?: string;
  children?: SubMenuItem[];
  icon: LucideIcon;
  key: string;
  label: string;
  onClick?: () => void;
  pending: boolean;
};

export type SubMenuItem = {
  key: string;
  label: string;
  onClick: () => void;
};

export function RoomOptionsMenu({
  anyActionPending,
  items,
}: {
  anyActionPending: boolean;
  items: MenuItem[];
}) {
  function renderItem(item: MenuItem) {
    if (!item.condition && !item.disabledTooltip) return null;

    if ("children" in item) {
      return (
        <DropdownMenuSub key={item.key}>
          <DropdownMenuSubTrigger className="flex w-full items-center">
            {item.icon ? <item.icon size={14} className="mr-2" /> : null}
            {item.label}
            {item.pending ? (
              <LoaderCircle className="ml-2 h-4 w-4 animate-spin" />
            ) : null}
          </DropdownMenuSubTrigger>
          <DropdownMenuSubContent sideOffset={8}>
            {item.children?.map((child) => {
              return (
                <DropdownMenuItem
                  onClick={child.onClick}
                  key={child.key}
                  onSelect={(evt) => evt.preventDefault()}
                >
                  {child.label}
                </DropdownMenuItem>
              );
            })}
          </DropdownMenuSubContent>
        </DropdownMenuSub>
      );
    }

    return (
      <Tooltip
        side="left"
        showArrow={true}
        tooltipContentText={!item.condition ? item.disabledTooltip : undefined}
      >
        <DropdownMenuItem
          key={item.key}
          onClick={item.onClick}
          disabled={anyActionPending || !item.condition}
          onSelect={(evt) => evt.preventDefault()}
        >
          {item.icon ? <item.icon size={14} className="mr-2" /> : null}
          {item.label}
          {item.pending ? (
            <LoaderCircle className="ml-2 h-4 w-4 animate-spin" />
          ) : null}
        </DropdownMenuItem>
      </Tooltip>
    );
  }

  return (
    <DropdownMenuContent align="end">
      <DropdownMenuLabel>Room Options</DropdownMenuLabel>
      <DropdownMenuSeparator />
      {items.map((item) => renderItem(item))}
    </DropdownMenuContent>
  );
}
